import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export type UpdateBrand = {
  name: string;
};

export const emptyBrand: UpdateBrand = {
  name: '',
};

export function updateBrand(id: number, brand: UpdateBrand) {
  return fetchWrapper({
    url: `/api/hardware/brand/${id}`,
    fetchArg: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: brand,
    },
  });
}
